import { SSEClientManager } from "@/shared/services/SSEClientManager";
import { baseURL, endpoints } from ".";

const firehoseSSEClient = new SSEClientManager({
  endpoint: baseURL + endpoints.stocksRatingsStream,
  connectionName: "Firehose-SSE",
});

export default firehoseSSEClient;
